import { useBrand } from '@/brand/BrandProvider'
import { BrandLogo } from './ui'

export function AuthLayout({
  title,
  subtitle,
  children,
}: {
  title: string
  subtitle?: string
  children: React.ReactNode
}) {
  const brand = useBrand()
  return (
    <div className="app-shell justify-center px-6 py-10">
      <div className="mb-8 flex flex-col items-center gap-3 text-center">
        <BrandLogo logoUrl={brand.logoUrl} appName={brand.appName} className="h-10" />
        <div>
          <h1 className="text-xl font-bold text-ink">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-ink-muted">{subtitle}</p>}
        </div>
      </div>
      <div className="w-full">{children}</div>
      <p className="mt-8 text-center text-[11px] leading-relaxed text-ink-faint">
        Al ingresar aceptás los términos y la política de privacidad.
      </p>
    </div>
  )
}
